'use client';
var classes = {"root":"m-b37d9ac7","notification":"m-5ed0edd0"};

export default classes;
//# sourceMappingURL=Notifications.module.mjs.map
